import { WhatsappCampaignFormInput } from '../../WhatsappCampaignValidation';

export const WHATSAPP_CONNECTOR_ID = 'cn-JOuCMxZBPX3s';
export const WHATSAPP_CONNECTOR_FLOW_NAME = 'Whatsapp Send Flow';
export const WHATSAPP_TEMPLATE_CONNECTOR_FLOW_NAME = 'Whatsapp Template Insert Flow';
export const WHATSAPP_CONNECTOR_NAME = 'Whatsapp Connector';
export const WHATSAPP_TEMPLATE_EDIT_FLOW_NAME = 'Whatsapp Template Edit Flow';
export const WHATSAPP_TEMPLATE_DELETE_FLOW_NAME = 'Whatsapp Template Delete Flow';

export const FINAL_SEND_REQUIRED_FIELDS: ReadonlyArray<keyof WhatsappCampaignFormInput> = [
  'name',
  'description',
  'templateId',
  'audienceId',
  'connectorFlowId',
  'connectorId',
];

export const FINAL_SEND_VALIDATION_ERROR_MESSAGE = 'Please complete required campaign fields before sending.';
export const FINAL_SEND_SUCCESS_MESSAGE = 'Send trigger placeholder executed successfully. Scheduling is coming soon.';
